module.exports = __webpack_public_path__ + "img/treeIcon.68e1e888.png";